import { Paper, Tab, Tabs, Typography } from '@material-ui/core'
import React from 'react'
import UGCForm from './UGCForm'

export default function UgcLanding({ apikey, username, role, history }) {
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <div>
      <Typography gutterBottom variant="h6">
        UGC Public Self Disclosure
      </Typography>

      <Paper square>
        <UGCForm apikey={apikey} />
      </Paper>

     

    </div>
  )
}


